<template>
  <div id="My" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">M</span>i Cuenta</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 t-c pt10 pb10 bg-color-white color-black">
      <div class="col-12 pt10 pb10">
        <img src="@/assets/user.png" class="r50 w15">
      </div>
      <div class="col-12 uppercase">
        {{ this.$store.state.account.name }}
      </div>
      <div class="f12 lh20">último acceso: {{ this.$store.state.account.last_time }}</div>
    </div>
    <div class="col-12 lh50 mt5">
      <div class="col-12 bg-color-white pl8 pr8" @click="go_profile()">
        <div class="col-2"><i class="iconfont icon-31wode color-primary f30"></i></div>
        <div class="col-9 bb1">Perfil</div>
        <div class="col-1 color-muted t-r bb1"><i class="iconfont icon-31fanhui2"></i></div>
      </div>
      <div class="col-12 bg-color-white pl8 pr8" @click="go_safety()">
        <div class="col-2"><i class="iconfont icon-anquan color-primary f30"></i></div>
        <div class="col-9 bb1">Seguridad</div>
        <div class="col-1 color-muted t-r bb1"><i class="iconfont icon-31fanhui2"></i></div>
      </div>
      <div class="col-12 bg-color-white pl8 pr8" @click="go_about()">
        <div class="col-2"><i class="iconfont icon-info color-primary f30"></i></div>
        <div class="col-9 bb">Acerca de la APP</div>
        <div class="col-1 color-muted t-r bb"><i class="iconfont icon-31fanhui2"></i></div>
      </div>
    </div>
    <div class="col-12 t-c-v mt10 bg-color-white lh50" @click="go_exit()">
      <div class="t-c"> Cerrar sesión</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'My',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
   //this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.user_type = this.$route.query.user_type;
      this.post(this.api_url + 'manage/my', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.users;
        }else{
          this.data_list = []
        }
      })
    },
    go_profile(){
      this.$router.push({name: 'M_Profile'});
    },
    go_safety(){
      this.$router.push({name: 'M_Safety'});
    },
    go_about(){
      this.$router.push({name: 'M_About'});
    },
    go_exit(){
      localStorage.setItem("token",'');
      this.$router.push({name:'Login'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/My.vue